import request from '@/utils/request'
// import { isUseAPI } from '@/utils/check'

export function getJuso(params) {
  return request({
    url: '/cmm/addr/getAddr',
    method: 'post',
    data: params
  })
}

export function getGeoCode(params) {
  return request({
    url:
      'https://naveropenapi.apigw.ntruss.com/map-geocode/v2/geocode?query=' +
      params.query,
    headers: {
      'X-NCP-APIGW-API-KEY-ID': params.clientID,
      'X-NCP-APIGW-API-KEY': params.apiKey
    },
    method: 'get'
  })
}
